//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA REMOVER INTEGRAÇÃO ---------------//
// Responsável por remover a integração via API
export default async function deleteIntegrationService(id) {
  try {
    await api.delete(`/integracoes/${id}`);
    toast.success("Integração removida com sucesso");
    return true;
  } catch (err) {
    console.error("❌ Erro ao remover integração:", err);
    toast.error("Erro ao remover integração");
    return false;
  }
}